import React from "react";
import svg from "../resources/images/notfound-img.svg";
import { Trans } from "react-i18next";

const NotFound = () => {
  return (
    <div className="contentview-wrapper container-lg my-3">
      <article className="content-sec detail-txt" id="error-page">
        <h1><Trans i18nKey="pages.notfound.h1" />{" "}- 404</h1>
        <h2 id="404-heading">
          <Trans i18nKey="pages.notfound.h2" />
        </h2>
        <img
          className="404-img"
          src={svg}
          alt="404-Bild"
          style={{ maxHeight: "33vh", margin: "2rem auto" }}
        />
      </article>
    </div>
  );
};

export default NotFound;
